import React, { useEffect, useState } from 'react';
export function UrgencyBanner() {
  const [dynamicDate, setDynamicDate] = useState('');
  useEffect(() => {
    const date = new Date();
    date.setDate(date.getDate() + 3);
    setDynamicDate(date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'short',
      day: 'numeric'
    }));
  }, []);
  return <div className="fixed top-0 left-0 w-full h-[44px] bg-gold-accent z-[1000] flex items-center justify-center px-4" data-id="element-530">
      <p className="text-primary-dark font-sans font-bold text-sm tracking-wide text-center uppercase" data-id="element-531">
        ⚡ LIMITED OFFER — The Debt-Free System: $9.99 Today. Price increases to
        $17.95 on {dynamicDate || 'SOON'}. Instant download.
      </p>
    </div>;
}